export default "__VITE_ASSET__DYRnS18n__"